import React, { useState } from 'react';
import { IconMenu, IconSize } from '@amzn/stencil-react-components/icons';
import { Flyout, FlyoutPosition } from '@amzn/stencil-react-components/flyout';
import { SideNav, SideNavItem, SideNavSection } from '@amzn/stencil-react-components/side-nav';
import { ButtonColorScheme, ButtonVariant } from '@amzn/stencil-react-components/button';
import { PageHeaderButton } from '@amzn/stencil-react-components/page';
import { DASHBOARD, POLICY_MARKETPLACE } from 'src/constants';
import { useNavigate } from 'react-router-dom';
import { ScreenReaderOnly } from '@amzn/stencil-react-components/screen-reader-only';

const SideNavigation = () => {
  const navigate = useNavigate();
  const [isMenuOpen, setMenuOpen] = useState<boolean>(false);

  const toggleNav = () => {
    setMenuOpen(!isMenuOpen);
  };

  const navigateFromSideNav = (navigationLink: string) => {
    toggleNav();
    navigate(navigationLink);
  };

  return (
    <>
      <PageHeaderButton
        color="neutral0"
        variant={ButtonVariant.Tertiary}
        colorScheme={ButtonColorScheme.DarkBackground}
        aria-label="Navigation Menu"
        onClick={toggleNav}
        icon={<IconMenu size={IconSize.Large} color="neutral0" />}
      />
      <Flyout
        aria-labelledby="policy-advisor-side-nav"
        isOpen={isMenuOpen}
        close={toggleNav}
        position={FlyoutPosition.Leading}
      >
        <ScreenReaderOnly id={'policy-advisor-side-nav'}>Policy Advisor</ScreenReaderOnly>
        <SideNav>
          <SideNavSection label="Policy Advisor">
            <SideNavItem
              tabIndex={0}
              role="link"
              onClick={() => {
                navigateFromSideNav(POLICY_MARKETPLACE);
              }}
            >
              Policy Marketplace
            </SideNavItem>
            <SideNavItem
              tabIndex={1}
              role="link"
              onClick={() => {
                navigateFromSideNav(DASHBOARD);
              }}
            >
              Dashboard
            </SideNavItem>
          </SideNavSection>
        </SideNav>
      </Flyout>
    </>
  );
};

export default SideNavigation;
